import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Box } from 'rebass';
import { connect } from 'unistore/react';

import { tooltipDataSelector } from '~/state/Selectors';
import { nf, parseLabel } from '~/Utils';

const TooltipWrapper = styled(Box).attrs({
  style: (props) => ({
    top: props.y,
    left: Math.max(props.x, 0),
  }),
})`
  display: block;
  position: absolute;
  width: 220px;
  background: rgba(255, 255, 255, 0.9);
  z-index: 1000;
  border: 1px solid ${(props) => props.theme.colors.lightblue};
  pointer-events: none;
  user-select: none;
  color: black;
`;

const TooltipHeadline = styled(Box)`
  font-weight: bold;
  margin-bottom: 3px;
`;

const TooltipItem = styled(Box)`
  line-height: 1.5;
`;

class Tooltip extends PureComponent {
  render() {
    const { tooltipX, tooltipY, tooltipVisible, tooltipData } = this.props;

    if (!tooltipVisible) {
      return null;
    }

    const population = nf(tooltipData['Bevölkerungsanteil']);
    const medianIncome = nf(tooltipData.Median);
    const povertyQuota = nf(tooltipData.Armutsrisikoquote);

    const isOutsideView = tooltipX + 300 > window.innerWidth;
    const xPos = isOutsideView ? tooltipX - 235 : tooltipX + 15;

    return (
      <TooltipWrapper
        isOutsideView={isOutsideView}
        p={1}
        x={xPos}
        y={tooltipY - 50}
      >
        <TooltipHeadline color="darkblue" fontSize={2}>
          {parseLabel(tooltipData.label)}
        </TooltipHeadline>
        <TooltipItem fontSize={1}>
          Bevölkerungsanteil: {population} Prozent
        </TooltipItem>
        <TooltipItem fontSize={1}>
          Medianeinkommen: {medianIncome} Euro
        </TooltipItem>
        <TooltipItem fontSize={1}>
          Armutsrisikoquote: {povertyQuota} Prozent
        </TooltipItem>
      </TooltipWrapper>
    );
  }
}

export default connect((state) => ({
  tooltipX: state.tooltipX,
  tooltipY: state.tooltipY,
  tooltipVisible: state.tooltipVisible,
  tooltipData: tooltipDataSelector(state),
}))(Tooltip);
